import React from 'react';
import { Stack, Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
var OfferListInformationPane = function (_a) {
    var status = _a.status, sampleOrderPeriod = _a.sampleOrderPeriod, orderPeriod = _a.orderPeriod, paymentPeriod = _a.paymentPeriod, estimatedDeliveryPeriod = _a.estimatedDeliveryPeriod;
    var t = useTranslation().t;
    return (React.createElement(Stack, { justifyContent: "space-between", divider: React.createElement(Divider, { orientation: "vertical", sx: { borderStyle: 'dashed', mx: 3, my: 0.5 }, flexItem: true }), sx: {
            flexDirection: {
                sm: 'column',
                md: 'row',
            },
            mt: { xs: 4, md: 6 },
            mb: { xs: 3, md: 5 },
        } },
        status && (React.createElement(Box, null,
            React.createElement(Box, { sx: {
                    mb: 0.5,
                    fontSize: {
                        sm: '12px',
                        md: '16px',
                    },
                    fontWeight: '600',
                } }, t('params.offerList.status')),
            React.createElement(Box, { sx: {
                    typography: {
                        sm: function (theme) { return theme.customTypography.body4; },
                        md: function (theme) { return theme.customTypography.body3; },
                    },
                } }, status))),
        React.createElement(Box, { sx: { flex: 1 } },
            React.createElement(Box, { sx: {
                    mb: 0.5,
                    typography: function (theme) { return theme.customTypography.subtitle1; },
                } }, t('pages.offerList.sampleOrderPeriod')),
            React.createElement(Box, { sx: {
                    typography: function (theme) { return theme.customTypography.body3; },
                } }, sampleOrderPeriod)),
        React.createElement(Box, { sx: { flex: 1 } },
            React.createElement(Box, { sx: {
                    mb: 0.5,
                    typography: function (theme) { return theme.customTypography.subtitle1; },
                } }, t('pages.offerList.orderPeriod')),
            React.createElement(Box, { sx: {
                    typography: function (theme) { return theme.customTypography.body3; },
                } }, orderPeriod)),
        React.createElement(Box, { sx: { flex: 1 } },
            React.createElement(Box, { sx: {
                    mb: 0.5,
                    typography: function (theme) { return theme.customTypography.subtitle1; },
                } }, t('pages.offerList.paymentPeriod')),
            React.createElement(Box, { sx: {
                    typography: function (theme) { return theme.customTypography.body3; },
                } },
                React.createElement("div", { style: { whiteSpace: 'pre-wrap' } }, paymentPeriod))),
        React.createElement(Box, { sx: { flex: 1 } },
            React.createElement(Box, { sx: {
                    mb: 0.5,
                    typography: function (theme) { return theme.customTypography.subtitle1; },
                } }, t('pages.offerList.estimatedDeliveryPeriod')),
            React.createElement(Box, { sx: {
                    typography: function (theme) { return theme.customTypography.body3; },
                } }, estimatedDeliveryPeriod))));
};
export default OfferListInformationPane;
